import debounce from 'lodash.debounce';
import { action, observable } from 'mobx';

import { MOBILE_MODE_WIDTH_THRESHOLD } from '../ui/mobile/constant';

/**
 * UI Store is the intended place where we keep track of all UI-specific state.
 * For example:
 *  - the width of the browser / whether we should trigger mobile mode
 *  - Whether drawer is opened
 *  - Whether page blanket should be triggered
 *
 * This store ABSOLUTELY should not contain any user data.
 */

export enum UILoadingState {
  LOADING,
  ERROR,
  READY_TO_RENDER,
}
interface AppLoadingState {
  products: UILoadingState;
}

export default class UIStore {
  @observable isFeedbackOpen: boolean = false;
  @observable
  loadingState: AppLoadingState = {
    products: UILoadingState.LOADING,
  };
  @observable mobileMode: boolean = window.screen.availWidth <= MOBILE_MODE_WIDTH_THRESHOLD;

  setOnMobileMode = debounce((width: number) => {
    if (!this.mobileMode && width <= MOBILE_MODE_WIDTH_THRESHOLD) {
      this.enableMobileMode();
    } else if (this.mobileMode && width > MOBILE_MODE_WIDTH_THRESHOLD) {
      this.disableMobileMode();
    }
  });

  @action
  disableMobileMode() {
    this.mobileMode = false;
  }

  @action
  enableMobileMode() {
    this.mobileMode = true;
  }

  @action
  setFeedbackClosed() {
    this.isFeedbackOpen = false;
  }

  @action
  setFeedbackOpen() {
    this.isFeedbackOpen = true;
  }
  @action
  setLoadingState(newState: Partial<AppLoadingState>) {
    this.loadingState = {
      ...this.loadingState,
      ...newState,
    };
  }
}
